module.exports = __webpack_public_path__ + "img/arrow_up_active.1f569ff7.svg";